var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.matchId && _vm.matchType)?_c(_vm.matchItemComp,{tag:"component",attrs:{"matchTypeProp":_vm.matchType,"liveTrackerForceEnabled":true}}):_vm._e(),(!_vm.matchId && !_vm.matchType)?_c('empty-state',{attrs:{"message":_vm.t(_vm.emptyStateMessage),"icon-class":_vm.emptyStateIcon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }